module.exports = __webpack_public_path__ + "static/img/JakartaReinhardRoya.f5807da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/JakartaReinhardRoya.jpg
// module id = 4rrf
// module chunks = 0